module.exports = __webpack_public_path__ + "assets/img/info-icon.384f770a.svg";